<div *ngIf="!isTopicDataLoaded" id="topic-header">
  <div class="topic-header">
    <div class="container">
      <h1></h1>
      <nav id="menuNavigation" class="navbar navbar-expand-lg navbar-light site-header-navigation">
        <div class="d-flex row col-12">
          <div class="d=flex col-1">
            <span class="navbar-brand">
              <a><img id="navBarImage" src="assets/images/mbtilogo.png" alt="MBTI Logo" class="mbti-logo-topic" /></a>
            </span>
          </div>
          <div class="d=flex col-10">
            <span id="topic-heading" class="navbar-brand topic-heading"></span>
          </div>
          <div class="d=flex col-1">
            <button
              class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span id="topic-close" class="nav-link" title="Save and close" (click)="close()"
                ><img id="mainImage" src="assets/images/close-static.svg" style="width: 30px" tabindex="0"
              /></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ms-auto" id="account-nav">
                <li class="nav-item" id="topicclose" tabindex="0">
                  <a id="topic-close" class="nav-link" title="Save and close" (click)="close()"
                    ><img id="mainImage" src="assets/images/close-static.svg" style="width: 30px" tabindex="0"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="container">
      <div class="spinner-container">
        <div class="d-flex justify-content-center">
          <div class="spinner-border custom-spinner" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isTopicDataLoaded" id="content-pages">
  <ng-container class="page-content" *ngFor="let page of pages">
    <div [hidden]="!page.show" id="page{{ page.pageNumber }}">
      <header id="topic-header">
        <div class="topic-header">
          <div class="container">
            <h1></h1>
            <nav id="menuNavigation" class="navbar navbar-expand-lg navbar-light site-header-navigation">
              <div class="d-flex row col-12">
                <div class="d-flex col-1 justify-content-start">
                  <span class="navbar-brand">
                    <a><img id="navBarImage" src="assets/images/mbtilogo.png" alt="MBTI Logo" class="mbti-logo-topic" /></a>
                  </span>
                </div>
                <div class="d-flex col-10">
                  <span
                    id="topic-heading"
                    class="navbar-brand topic-heading d-flex justify-content-center w-100 text-wrap"
                    [innerHtml]="page.pageTitle | safeHtml"
                  ></span>
                </div>
                <div class="d-flex col-1 justify-content-end">
                  <button class="navbar-toggler" type="button" aria-label="Close course">
                     <span id="topic-close" class="nav-link" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-trigger="hover" title="Save and close" (click)="saveAndClose(page.pageNumber)"><img id="mainImage" src="assets/images/close-static.svg" style="width: 30px" tabindex="0" /></span>
                  </button>

                  <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto" id="account-nav">
                      <li class="nav-item" id="topicclose" tabindex="0">
                         <a id="topic-close" class="nav-link" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-trigger="hover" title="Save and close" (click)="saveAndClose(page.pageNumber)"><img id="mainImage" src="assets/images/close-static.svg" style="width: 30px" tabindex="0" /></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </header>

      <div id="topic-body" class="container topic-body">
        <div class="page-details" [innerHtml]="page.html | safeHtml"></div>
        <input type="hidden" id="current-page" value="{{ page.pageNumber }}" />
        <input type="hidden" id="page-id" value="{{ page.pageId }}" />
        <input type="hidden" id="show-per-page" value="1" />
        <input type="hidden" id="page-title" value="{{ page.pageTitle }}" />
      </div>

      <footer id="topic-footer" class="topic-footer">
        <div class="progress">
          <div class="progress-bar" [style.width]="page.percentageCompleted + '%'"></div>
        </div>
        <div class="site-footer-navigation">
          <nav class="course-navigation">
            <div class="gridContainer">
              <a href="javascript:void(0);" class="primary-back-link nav-back" (click)="previous(page)">Previous</a>
              <button class="btn-primary nav-next" id="next-button" (click)="next(page)">
                {{ page.pageNumber === totalPages ? nextTopicName : 'Next' }}
              </button>
            </div>
            <div class="ios-shim"><br /><br /></div>
          </nav>
        </div>
      </footer>
    </div>
  </ng-container>
</div>
